// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Controls_wrapper__2Jg0k","btns":"Controls_btns__3_M40"};